<template>
<section class="maininfo temp__flexbox width--100p temp__jc--c">
    <div class="temp__flexbox temp__fw--w temp__jc--c width--100p mw--1280">
        <!-- write your HTML for the left column here -->
        <div class="maininfo__left-col width--50p width--100p--768 height--auto--600">
            <div class="temp__flexbox temp__ai--fs ta--left">
              <h1>It's in our nature</h1>
            </div>
            <div class="maininfo__copy temp__flexbox temp__ai--fs ta--left">
              <p>We Danes love to share, it's in our&nbsp;nature. 
                  <br><br>
                  That's why at Carlsberg we've been exporting our first beer since 1869. Carlsberg Danish Pilsner Beer is best served chilled in our Pilsner glass, which has been designed specifically to enhance your enjoyment of our beer. For the perfect serve, hold the glass at 45 degrees and pour to three quarters full, before slowly straightening to develop the head as you top&nbsp;up.
              </p>
            </div>
            <div class="temp__flexbox temp__ai--fs temp__jc--fs ta--left pb--20 pb--0--600">
              <h2>Skål!</h2>
            </div>
        </div>
        <!-- write your HTML for the right column here -->
        <div class="maininfo__images temp__flexbox width--100p--600 width--50p  height--auto--600 py--20--600 width--100p--768">
            <div class="maininfo__img-wrapper temp__flexbox width--50p temp__ai--c temp__jc--c">
               <video class="width--100p" id="video" role="presentation" preload="auto" playsinline crossorigin="anonymous" loop muted autoplay>
            <source src="images/exports/carlsberg-tap.mp4" type="video/mp4">
        </video>
            </div>
            <div class="maininfo__img-wrapper temp__flexbox width--50p temp__ai--c temp__jc--c">
                <img class="width--100p" src="images/exports/running-tap-2.gif">
            </div>
        </div>
   
    </div>   
</section>
<section class="temp__flexbox width--100p temp__jc--c">
<div class="temp__flexbox temp__jc--c width--100p mw--1280">
    <div class="width--100p width--100p--600 height--auto--600 pb--50 pt--20">
            <div class="temp__flexbox temp__ai--c temp__jc--c d--none--mob">
              <video class="width--100p" id="video" role="presentation" preload="auto" playsinline crossorigin="anonymous" loop muted autoplay>
            <source src="images/exports/beer16x9.mp4" type="video/mp4">
        </video>
            </div>
            <div class="temp__flexbox temp__ai--c temp__jc--c d--block--mob">
              <video class="width--100p" id="video" role="presentation" preload="auto" playsinline crossorigin="anonymous" loop muted autoplay>
            <source src="images/exports/beer4x5.mp4" type="video/mp4">
        </video>
            </div>
        </div>
    </div>
</section>

<div class="footer width--100p temp__flexbox temp__ai--c temp__jc--c ta--c py--30 px--20" style="border-top: 1px solid #f0f0f0;">
    <div class="container">
        <div class="footer-row middle">
            <div class="terms-copy pt--20">
                <a href="https://www.channelsight.com/privacy-policy-diageo" target="_blank" style="color: #000000;text-decoration: underline;font-size: 12px;">READ THE PRIVACY POLICY HERE</a><br><br><p style="font-size: 12px;">Please do not share with anyone under the legal purchase age for alcohol. Drink Responsibly.</p>
            </div>
        </div>
    </div>
</div>

</template>

<script setup>

import dataModel from '../js/model.js';
const props = defineProps({
  brandExperience: {
    type: String,
    default: "1"
  },
});
$(document).ready(function() {
  $('.navbar').css({
    backgroundColor: dataModel[props.brandExperience].ui.primaryColor
  });
  
})

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.footer {
    @media(max-width: 600px) {
        padding-bottom: 130px;
    }
}
.product {
    padding: 100px 0px 50px 0px;
}
.product__copy {
    color: $color--green;
    font-size: 38px;
    font-weight: bold;
    line-height: 50px;
    @media(max-width: 600px) {
        padding-right: 20px;
        padding-left: 20px;
        text-align: left;
    }
}
.maininfo {
    padding-top: 20px;
}
.maininfo__left-col {
    @media(max-width: 1380px) {
        padding-left: 50px;
    }
    @media(max-width: 600px) {
        padding-right: 20px;
        padding-left: 20px;
    }
}
.maininfo__copy {
    padding-right: 100px;
    @media(max-width: 600px) {
        padding-right: 0px;
    }
}
.maininfo__images {
    padding-bottom: 20px;
    @media(max-width: 600px) {
        padding-left: 20px;
        padding-right: 20px;
    }
}
.maininfo__img-wrapper {
    &:first-child {
        padding-right: 10px;
        @media(max-width: 600px) {
            
        }
    }
    &:last-child {
        padding-left: 10px;
        @media(max-width: 600px) {
            
        }
    }
}

.img--h-70 {
    height: 150px;
    @media(max-width: 768px) {
        height: 100px;
    }
}

.d--none--mob {
    @media(max-width: 600px) {  
        display: none !important;
    }
}

.d--block--mob {
    display: none;
    @media(max-width: 600px) {  
        display: block !important;
    }
}
.terms-copy {
    @media(max-width: 600px) {  
        padding-bottom: 100px;
    }
}
</style>
